import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group col-10 ps-2 pt-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "assigned-to" }, " Document Name: ", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_4 = { class: "form-group col-10 pt-2 ps-2 hh-document-type" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "assigned-to" }, " Document Type: ", -1 /* HOISTED */)
const _hoisted_6 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Edit Referral Document",
    "full-height": true,
    "application-id": _ctx.options.application,
    class: "p-2"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Enter Name",
          class: _normalizeClass(["form-control", `${!_ctx.v$.fileName.$error ? '' : 'field-invalid'}`]),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileName) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.fileName.$touch && _ctx.v$.fileName.$touch(...args)))
        }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
          [_vModelText, _ctx.fileName]
        ]),
        (_ctx.v$.fileName.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Document Name is required."))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_TypeaheadInput, {
          placeholder: "Start Typing...",
          data: _ctx.searchedTypes,
          value: _ctx.selectedUploadType,
          onValueChanged: _ctx.uploadTypeChanged,
          showAllByDefault: true,
          openOnFocus: true
        }, null, 8 /* PROPS */, ["data", "value", "onValueChanged"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-light border border-secondary me-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
        }, " Cancel "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary border border-primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ok()))
        }, "Save")
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}